import { TABLE_SEARCHES_TYPES } from "../config/constants";
import { store } from "../store/store";

export const getTableSearches = (pageContext, tableContext) => {
	const tablesSearches = store.getState().user.tablesSearches;

	let meta = null;
	let sortField = null;
	let sortDirection = null;
	let searchText = null;
	let filters = { byStatuses: [] };
	let rowsPerPage = 10;

  if (tablesSearches) {
    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.META)
    ) {
      meta = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.META];
    }

    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.SORT_FIELD)
    ) {
      sortField = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.SORT_FIELD];
    }

    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.SORT_DIRECTION)
    ) {
      sortDirection = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.SORT_DIRECTION];
    }

    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.SEARCH_TEXT)
    ) {
      searchText = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.SEARCH_TEXT];
    }

    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.FILTERS)
    ) {
      filters = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.FILTERS];
    }

    if (tablesSearches.hasOwnProperty(pageContext) &&
      tablesSearches[pageContext].hasOwnProperty(tableContext) &&
      tablesSearches[pageContext][tableContext].hasOwnProperty(TABLE_SEARCHES_TYPES.ROWS_PER_PAGE)
    ) {
      rowsPerPage = tablesSearches[pageContext][tableContext][TABLE_SEARCHES_TYPES.ROWS_PER_PAGE];
    }
  }

	return {
		meta: meta,
		sortField: sortField,
		sortDirection: sortDirection,
		searchText: searchText,
		filters: filters,
		rowsPerPage: rowsPerPage,
	};
}